import React, {useState, useRef, useEffect} from 'react';
import axios from 'axios';
import Box from "@mui/material/Box";
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import IconButton from "@mui/material/IconButton";
import { url } from '../../../Config';


export default function Consultancy_received(props) {

    const date1Ref = useRef(null);
    const serviceRef = useRef(null);
    const service_durRef = useRef(null);
    const detailRef = useRef(null);
    const countrynameRef = useRef(null);
    const RemunerationRef = useRef(null);
    const optionRef = useRef(null);
    const btnRef = useRef(null);


    const [alertopen, setalertOpen] = useState(false);
    const [alertType, setalertType] = useState();
    const [AlertMessage, setalertmessage] = useState();

    const submitForm = async (event)=>{
        event.preventDefault();
        setalertOpen(false);

        if(optionRef.current.value == ''){
            setalertType("error");
            setalertOpen(true);
            setalertmessage('Please Select An Option from "Current Status" field');
            return;
        }

        const res = await axios.post(`${url}/api/storeConsultancyBd`, {
            'date': date1Ref.current.value,
            'service': serviceRef.current.value,
            'details': detailRef.current.value,
            'service_duration': service_durRef.current.value,
            'counter_party_name': countrynameRef.current.value,
            'remuneration': RemunerationRef.current.value,
            'status': optionRef.current.value,

        })

        const resp = res.data;
        if(resp.status == true){
            btnRef.current.disabled = false;
            setalertType("success");
            setalertOpen(true);
            setalertmessage(resp.message);
        }
        else{
            btnRef.current.disabled = false;
            setalertType("error");
            setalertOpen(true);
            setalertmessage(resp.message);
        }

    }

  return (
    <div style={{height: '90vh'}}>
       <div className='text-center mt-2 fs-4 fw-bold' style={{color: "#000078" }}>
            Consultancy Received
        </div>
        <form className ='col-10 card shadow p-3 mx-auto mt-2' onSubmit={(event)=>{submitForm(event)}}>
        <div>
            <div className='mt-2 fw-bold'>
                Date
            </div>
            <div className='mt-2'>
                <input className='form-control' type='date' ref={date1Ref} required />
            </div>
        </div>
        <div>
            <div className='fw-bold mt-2'>
                Service
            </div>
            <div className='mt-2'>
                <input className='form-control' ref={serviceRef} required />
            </div>
        </div>
        <div>
            <div className='fw-bold mt-2'>
                Detail Of Service
            </div>
            <div className='mt-2'>
                <textarea className='form-control' ref={detailRef} placeholder='Enter Detail Here' required />
            </div>
        </div>
        <div>
            <div className='fw-bold mt-2'>
                Duration of Service
            </div>
            <div className='mt-2'>
                <input className='form-control' ref={service_durRef} required />
            </div>
        </div>
        <div>
            <div className='fw-bold mt-2'>
                Name Of Counter Party
            </div>
            <div className='mt-2'>
                <input className='form-control' ref={countrynameRef} placeholder='Name Of Counter Party' required />
            </div>
        </div>
        <div>
            <div className='fw-bold mt-2'>
                Remuneration
            </div>
            <div className='mt-2'>
                <input className='form-control' ref={RemunerationRef} required />
            </div>
        </div>

        <div>
            <div className='mt-2 fw-bold'>
                Current Status
            </div>
            <div className='mt-2'>
                <select className='form-select' ref={optionRef}>
                    <option value="">Select Status</option>
                    <option value="1">In-Process</option>
                    <option value="2">Closed</option>
                    <option value="4">Active</option>
                    <option value="3">Status Details</option>
                </select>
            </div>
        </div>
        <Box className="mx-auto mt-1 mb-1" sx={{ width: "98%" }}>
            <Collapse in={alertopen}>
                <Alert
                severity={alertType}
                action={
                    <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                        setalertOpen(false);
                    }}
                    >
                    <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                sx={{ mb: 2 }}
                >
                {AlertMessage}
                </Alert>
            </Collapse>
        </Box>
        <div className='mt-3'>
            <button className='btn btn-primary' ref={btnRef}  type='submit'>Save</button>
        </div>
        </form>
    </div>
  )
}
